import defaultSettings from '../settings.json';
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    isSuper: any;
    resourceList?: any[];
    permissions?: any;
    admin?: boolean;
    id?: string;
    nickName?: string;
    userType?: number;
    username?: string;
    resources?: any[];
  };
  userLoading?: boolean;
  frameDetailConfig?: {
    visible: boolean;
    id: number | null;
  };
  lensDetailConfig?: {
    visible: boolean;
    id: number | null;
  };
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: [],
    resources: [],
    resourceList: [],
    isSuper: 0,
  },
  frameDetailConfig: {
    visible: false,
    id: null,
  },
  lensDetailConfig: {
    visible: false,
    id: null,
  },
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings': {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case 'update-userInfo': {
      const { userInfo = initialState.userInfo, userLoading } = action.payload;
      // if (userInfo.isSuper === 1) {
      //   userInfo.permissions = ['*'];
      // }
      return {
        ...state,
        userLoading,
        userInfo,
      };
    }
    case 'update-frameDetailConfig': {
      const { frameDetailConfig } = action.payload;
      return {
        ...state,
        frameDetailConfig,
      };
    }
    case 'update-lensDetailConfig': {
      const { lensDetailConfig } = action.payload;
      return {
        ...state,
        lensDetailConfig,
      };
    }
    default:
      return state;
  }
}
